/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type AutopilotSuggestionsCard_org = {
    readonly id: string;
    readonly tailoredDefragCardSummary: ({
        readonly __typename: "TailoredDefragCardSummary";
        readonly defragTime: unknown;
        readonly impactedOtherCalendarIds: ReadonlyArray<string>;
        readonly valueStrings: ReadonlyArray<string>;
        readonly knobs: {
            readonly inviteOrganizerKnobs: ReadonlyArray<{
                readonly __typename: string;
                readonly knobUrn: {
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                };
                readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionInvite_inviteOrganizerKnob">;
            }>;
            readonly autopilotMeetingKnobs: ReadonlyArray<{
                readonly __typename: string;
                readonly knobUrn: {
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                };
                readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionEnableMeeting_autopilotMeetingKnob">;
            }>;
            readonly lessenAutopilotConstraintKnobs: ReadonlyArray<{
                readonly __typename: string;
                readonly knobUrn: {
                    readonly id: string;
                    readonly type: UrnType | null;
                    readonly value: string | null;
                };
                readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob">;
            }>;
        };
        readonly referencedEvents: ReadonlyArray<{
            readonly eventKey: {
                readonly externalEventId: string;
            };
            readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionInvite_referencedEvents" | "AutopilotSuggestionEnableMeeting_referencedEvents" | "AutopilotSuggestionLessenConstraint_referencedEvents">;
        }>;
        readonly persons: {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly primaryEmail: string;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly rooms: {
            readonly __typename: "RoomList";
            readonly list: ReadonlyArray<{
                readonly roomId: string;
                readonly name: string;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionInvite_org" | "AutopilotSuggestionEnableMeeting_org" | "AutopilotSuggestionLessenConstraint_org">;
    readonly " $refType": "AutopilotSuggestionsCard_org";
};
export type AutopilotSuggestionsCard_org$data = AutopilotSuggestionsCard_org;
export type AutopilotSuggestionsCard_org$key = {
    readonly " $data"?: AutopilotSuggestionsCard_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionsCard_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "knobUrn",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AutopilotSuggestionsCard_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tailoredDefragCardSummary",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defragTime",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "impactedOtherCalendarIds",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "valueStrings",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DefragValueKnobs",
                                "kind": "LinkedField",
                                "name": "knobs",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "InviteOrganizerKnob",
                                        "kind": "LinkedField",
                                        "name": "inviteOrganizerKnobs",
                                        "plural": true,
                                        "selections": [
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "AutopilotSuggestionInvite_inviteOrganizerKnob"
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AutopilotMeetingKnob",
                                        "kind": "LinkedField",
                                        "name": "autopilotMeetingKnobs",
                                        "plural": true,
                                        "selections": [
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "AutopilotSuggestionEnableMeeting_autopilotMeetingKnob"
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LessenAutopilotConstraintKnob",
                                        "kind": "LinkedField",
                                        "name": "lessenAutopilotConstraintKnobs",
                                        "plural": true,
                                        "selections": [
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "referencedEvents",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventKey",
                                        "kind": "LinkedField",
                                        "name": "eventKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "externalEventId",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AutopilotSuggestionInvite_referencedEvents"
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AutopilotSuggestionEnableMeeting_referencedEvents"
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AutopilotSuggestionLessenConstraint_referencedEvents"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "persons",
                                "plural": false,
                                "selections": [
                                    (v1 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Person",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "primaryEmail",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "UserProfile",
                                                        "kind": "LinkedField",
                                                        "name": "profile",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "givenName",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "familyName",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "externalImageUrl",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "PersonList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rooms",
                                "plural": false,
                                "selections": [
                                    (v1 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Room",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "roomId",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "name",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "RoomList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TailoredDefragCardSummary",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotSuggestionInvite_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotSuggestionEnableMeeting_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotSuggestionLessenConstraint_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'e03f9163d39e61d188450113d469e64e';
export default node;
